module.exports = __webpack_public_path__ + "img/logo.fca3af18.png";